import { ChangeDetectorRef } from "@angular/core";
import { AudioService } from "./audio";
import { delay, jkLib } from "./jkCommon";
import { CR } from "./jkInterface";

interface RecommendedVoices {
  [key: string]: boolean;
}

// https://translate.google.com/translate_tts?ie=UTF-8&client=tw-ob&q=%E4%BD%A0%E5%A5%BD&tl=zh
export class webSpeechClass {
  public sayCommand: string;
  public recommendedVoices: RecommendedVoices;
  public rates: number[];
  public selectedRate: number;
  public selectedVoice: SpeechSynthesisVoice | null;
  public text: string;
  public voiceIndex: number = 21;
  public voices: SpeechSynthesisVoice[];
  audio: AudioService;
  private cdr?: ChangeDetectorRef;
  constructor(cdr?: ChangeDetectorRef){
    this.cdr = cdr;
    this.voices = [];
    this.rates = [.25, .5, .75, 1, 1.25, 1.5, 1.75, 2];
    this.selectedVoice = null;
    this.selectedRate = 1;
    // Dirty Dancing for the win!
    this.text = "傑克你好.";
    this.sayCommand = "";

    // These are "recommended" in so much as that these are the voices that I (Ben)
    // could understand most clearly.
    // https://sites.google.com/a/vomasterclass.com/recommendedvoices/
    this.recommendedVoices = Object.create(null);
    this.recommendedVoices["Alex"] = true;
    this.recommendedVoices["Alva"] = true;
    this.recommendedVoices["Damayanti"] = true;
    this.recommendedVoices["Daniel"] = true;
    this.recommendedVoices["Fiona"] = true;
    this.recommendedVoices["Fred"] = true;
    this.recommendedVoices["Karen"] = true;
    this.recommendedVoices["Mei-Jia"] = true;
    this.recommendedVoices["Melina"] = true;
    this.recommendedVoices["Moira"] = true;
    this.recommendedVoices["Rishi"] = true;
    this.recommendedVoices["Samantha"] = true;
    this.recommendedVoices["Tessa"] = true;
    this.recommendedVoices["Veena"] = true;
    this.recommendedVoices["Victoria"] = true;
    this.recommendedVoices["Yuri"] = true;
    this.init();
    this.audio = new AudioService(); // 'pristine.mp3'
  }
  init(){
    this.voices = speechSynthesis.getVoices();
    this.selectedVoice = (this.voices[0] || null);
    this.updateSayCommand();

    // The voices aren't immediately available (or so it seems). As such, if no
    // voices came back, let's assume they haven't loaded yet and we need to wait for
    // the "voiceschanged" event to fire before we can access them.
    if (!this.voices.length) {

      speechSynthesis.addEventListener(
        "voiceschanged",
        () => {

          this.voices = speechSynthesis.getVoices();
          this.selectedVoice = (this.voices[0] || null);
          this.updateSayCommand();
          this.cdr?.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式

        }
      );
      }
    this.voiceIndex = this.language2VoiceIndex('zh-TW'); // prompt("Please enter a string:");

  }
  // ---
  // PUBLIC METHODS.
  // ---

  // I demo the currently-selected voice.
  public demoSelectedVoice(): void {

    if (!this.selectedVoice) {

      console.warn("Expected a voice, but none was selected.");
      return;

    }

    var demoText = "Best wishes and warmest regards.";

    this.stop();
    this.synthesizeSpeechFromText(this.selectedVoice, this.selectedRate, demoText);

  }
  // I synthesize speech from the current text for the currently-selected voice.
  public speak(): void {

    if (!this.selectedVoice || !this.text) {

      return;

    }

    this.stop();
    this.synthesizeSpeechFromText(this.selectedVoice, this.selectedRate, this.text);

  }
  public speakText(xText:string,voiceIndex:number,xRate:number): void {
    if(voiceIndex < 0){
      for(let i=0;i<this.voices.length;i++){
        if(this.voices[i].lang.indexOf("zh-TW")>=0){
          voiceIndex = i;
          break;
        }
      };
    }
    if (!this.selectedVoice || !this.text) {
      return;
    }
    this.stop();
    this.synthesizeSpeechFromText(this.voices[voiceIndex], xRate, xText);

  }
  public speakLanguage(language:string,message:string,xRate:number=1){
    if(language === "zh"){
      language = "zh-TW";
    }
    let voiceIndex = this.language2VoiceIndex(language);
    this.speakText(message,voiceIndex,xRate);
  }
  language2VoiceIndex(language:string):number{
    let result = -1;
    if(this.voices.length === 0){
      return result;
    }
    for(let i=0;i<this.voices.length;i++){
      if((this.voices[i].lang.indexOf(language)>=0) && (this.voices[i].localService===true)){
        result = i;
        break; // return result;
      }
    };
    if(result<0){
    for(let i=0;i<this.voices.length;i++){
      if((this.voices[i].lang.indexOf(language)>=0)){
        result = i;
        break; // return result;
      }
    };
  }
    if(result<0){
      result = 0;
      //alert("不支援語言:"+language);
      console.log("不支援語言:"+language);
    }
    if(result === 0){
      result = 21; // google 中文較好聽
    }
    return result;
  }
  // I stop any current speech synthesis.
  public stop(): void {

    if (speechSynthesis.speaking) {

      speechSynthesis.cancel();

    }

  }


  // I update the "say" command that can be used to generate the a sound file from the
  // current speech synthesis configuration.
  public updateSayCommand(): void {

    if (!this.selectedVoice || !this.text) {

      return;

    }

    // With the say command, the rate is the number of words-per-minute. As such, we
    // have to finagle the SpeechSynthesis rate into something roughly equivalent for
    // the terminal-based invocation.
    var sanitizedRate = Math.floor(200 * this.selectedRate);
    var sanitizedText = this.text
      .replace(/[\r\n]/g, " ")
      .replace(/(["'\\\\/])/g, "\\$1")
      ;

    this.sayCommand = `say --voice ${this.selectedVoice.name} --rate ${sanitizedRate} --output-file=demo.aiff "${sanitizedText}"`;

  }

  // ---
  // PRIVATE METHODS.
  // ---

  // I perform the low-level speech synthesis for the given voice, rate, and text.
  private synthesizeSpeechFromText(
    voice: SpeechSynthesisVoice,
    rate: number,
    text: string
  ): void {

    var utterance = new SpeechSynthesisUtterance(text);
    //utterance.voice = this.selectedVoice;
    utterance.voice = voice;
    utterance.rate = rate;

    speechSynthesis.speak(utterance);

  }
  getSettings():string{
    let v = '';
    for(let i=0;i<this.voices.length;i++){
      v += 'name:'+JSON.stringify(this.voices[i].name)+','+
        'default:'+JSON.stringify(this.voices[i].default)+','+
        'lang:'+JSON.stringify(this.voices[i].lang)+','+
        'voiceURI:'+JSON.stringify(this.voices[i].voiceURI)+','+
        'localService:'+JSON.stringify(this.voices[i].localService)+','+
      CR;
    };
    let msg = '有複製到clipboard.'+CR+'voiecs:'+v+CR+
    'recommendedVoices:'+JSON.stringify(this.recommendedVoices)+CR+
    'selectedRate:'+this.selectedRate;
    jkLib.copy2Clipboard(msg);
    return msg;
  }
  showSettings(){
    alert(this.getSettings());
  }
  async webSpeech(isMusic: boolean, message: string) {
    if (!message) return;
    if (message === '') return;
    //console.log('myWebSpeech message:' + message);
    //this.az.speechTTS(message, this.ret);
    if (isMusic) {
      //await this.myBeep(1);
      this.audio.beep(2);
      await delay(1000);
    }
    // message 刪掉emoji 字元
    message = message.replace(/[\u{1F600}-\u{1F64F}]/ug, '');
    this.speakText(message, this.voiceIndex, 1);
    //this.az.azure_pubpublish(pubsub_opt,message);

    //this.myMessage(message);
  }

}
